import { BiErrorCircle } from "react-icons/bi";

export const FormError = ({ message }) => {
  return (
    <div className="flex items-center text-red-500 text-sm font-body font-light mt-1 ">
      <BiErrorCircle className="mr-2 h-4" />
      <p>{message}</p>
    </div>
  );
};
